import { inspectionCheckKey } from './manager'

function checkLabel(check) {
  if (check.label) return check.label
  if (check.core === 'modfields') return 'Modification'
  if (check.core === 'showfields' || check.core === 'fields' || check.core === 'page' || check.core === 'modules' || check.core === 'tabs') return 'Visibilité'
  const operations = { watch: 'Consultation', update: 'Modification', insert: 'Création', delete: 'Suppression', export: 'Export' }
  return operations[check.id] || (check.core === 'actions' ? 'Action' : 'Autorisation')
}

export function inspectionPresentation(checks, results) {
  const entries = checks.map(check => ({ check, result: results[inspectionCheckKey(check)] }))
  const pending = entries.some(entry => !entry.result)
  const failed = entries.some(entry => entry.result && entry.result.error)
  const denied = entries.filter(entry => entry.result && entry.result.allowed === false)
  const conditional = entries.some(entry => entry.result && (entry.result.conditional || entry.result.allowed === null))
  const individuals = entries.filter(entry => entry.result && entry.result.individual)
  const visibilityDenied = denied.some(({ check }) => ['page', 'modules', 'showfields', 'fields', 'tabs'].includes(check.core) || check.id === 'watch')
  const personalDenial = individuals.some(({ result }) => result.allowed === false)
  const personalGrant = individuals.some(({ result }) => result.allowed === true && result.role_allowed === false)
  let icon = 'mdi-eye-outline', color = 'success', status = 'Autorisé'
  if (denied.length) { icon = visibilityDenied ? 'mdi-eye-off-outline' : 'mdi-lock-outline'; color = 'warning'; status = visibilityDenied ? 'Masqué' : 'Accès limité' }
  else if (pending || failed) { icon = failed ? 'mdi-help-circle-outline' : 'mdi-progress-clock'; color = 'grey'; status = failed ? 'Évaluation indisponible' : 'Évaluation en cours' }
  else if (conditional) { icon = 'mdi-clock-outline'; color = 'info'; status = 'Accès conditionnel' }
  return {
    icon, color, status, individual: individuals.length > 0,
    personColor: personalDenial ? 'warning' : personalGrant ? 'success' : 'info',
    lines: entries.map(({ check, result }) => !result ? checkLabel(check) + ' : évaluation en cours.'
      : checkLabel(check) + ' : ' + (result.error ? 'indisponible' : result.allowed === true ? 'autorisé' : result.allowed === false ? 'interdit' : 'conditionnel')
        + (result.reason ? ' — ' + result.reason : '') + (result.individual ? ' · Attribution individuelle explicite.' : '')),
  }
}
